export class RecuperarPassClavePeticion {
	//public codCliente: string = '';
	public docEmpresa: string = '';
	public correoUsuario: string = '';
	//public codTpoPortal: string = '';
	public claveUsuario: string = '';
	//public movilUsuario: string = '';
	//public countryMovilUsuario: string = '';
	public tipoEnvio: string = '';
}